import { DialogTitle } from '@headlessui/react'
import React from 'react'
import CentsDialog from '../../../../common/dialogs/Dialog'

interface Props {
  children: React.ReactNode
  title: string
  visible: boolean
  close: () => void
}
export function ChangeContractDialog({ children, title, visible, close }: Props): JSX.Element {
  return (
    <CentsDialog opened={visible} cancel={close}>
      <div className="flex flex-col items-center justify-center">
        <DialogTitle as="h3" className="text-base font-semibold text-gray-900 mb-6">
          {title}
        </DialogTitle>
        {children}
      </div>
    </CentsDialog>
  )
}
